var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 20C5.16 20 4.7832 19.8432 4.4696 19.5296C4.156 19.216 3.99947 18.8395 4 18.4V8C4 7.77333 4.0768 7.5832 4.2304 7.4296C4.384 7.276 4.57387 7.19947 4.8 7.2C5.02667 7.2 5.2168 7.2768 5.3704 7.4304C5.524 7.584 5.60053 7.77387 5.6 8V18.4H13.6C13.8267 18.4 14.0168 18.4768 14.1704 18.6304C14.324 18.784 14.4005 18.9739 14.4 19.2C14.4 19.4267 14.3232 19.6168 14.1696 19.7704C14.016 19.924 13.8261 20.0005 13.6 20H5.6ZM8.8 16.8C8.36 16.8 7.9832 16.6432 7.6696 16.3296C7.356 16.016 7.19947 15.6395 7.2 15.2V5.6C7.2 5.16 7.3568 4.7832 7.6704 4.4696C7.984 4.156 8.36053 3.99947 8.8 4H16C16.44 4 16.8168 4.1568 17.1304 4.4704C17.444 4.784 17.6005 5.16053 17.6 5.6V15.2C17.6 15.64 17.4432 16.0168 17.1296 16.3304C16.816 16.644 16.4395 16.8005 16 16.8H8.8Z",
    fill: "#81FEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.f4e6b02f9346ff3ea49b3a254732bf01.svg";
export { ForwardRef as ReactComponent };